import { render, staticRenderFns } from "./NLPAnalyzer.vue?vue&type=template&id=1ed42d9e&"
import script from "./NLPAnalyzer.vue?vue&type=script&lang=js&"
export * from "./NLPAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports